import styled from 'styled-components';

import OutputText from '@ey/canvascoreservices/OutputText';

export default styled(OutputText)`
	display: inline;
	& > * {
		display: inline;
		vertical-align: bottom;
		line-height: normal;
		height: unset;
	}
`;
